import * as React from 'react';
import './index.css';

interface Props {
  payComponentData: PayComponentData;
  onPayComponentCallback?: (event: PayComponentCallbackEvent) => void;
}

export enum BizType {
  SailorPreCashier = 'sailor_pre_cashier'
}

export interface PayComponentData {
  bizType: BizType;
  bizData?: any;
}

export interface PayComponentCalledEvent {
  payAction: string; // 对应的业务场景
  payData?: any; // 对应业务场景的业务数据，不同业务场景的业务数据格式不同
}

export interface PayComponentCallbackEvent {
  payAction: string; // 对应的业务场景
  payData?: any; // 对应业务场景的业务数据，不同业务场景的业务数据格式不同
}

class PayComponent extends React.PureComponent<Props, any> {
  payRef: React.RefObject<any> = React.createRef();

  callPayComponent = (event: PayComponentCalledEvent) => {
    this.payRef.current.callPayComponent(JSON.stringify(event));
  }

  render() {
    const { payComponentData, onPayComponentCallback } = this.props;
    return (
      <pay-component
        className="pay-component"
        ref={this.payRef}
        payComponentData={payComponentData}
        onPayComponentCallback={onPayComponentCallback}
      />
    );
  }
}

export default PayComponent;
